var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetupTracking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01677 10.5917C1.90328 10.412 1.84654 10.3222 1.81477 10.1836C1.79091 10.0795 1.79091 9.91531 1.81477 9.81122C1.84654 9.67263 1.90328 9.58278 2.01677 9.40308C2.95461 7.9181 5.74617 4.16406 10.0003 4.16406C14.2545 4.16406 17.0461 7.9181 17.9839 9.40308C18.0974 9.58278 18.1541 9.67263 18.1859 9.81122C18.2098 9.91531 18.2098 10.0795 18.1859 10.1836C18.1541 10.3222 18.0974 10.412 17.9839 10.5917C17.0461 12.0767 14.2545 15.8307 10.0003 15.8307C5.74617 15.8307 2.95461 12.0767 2.01677 10.5917Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 12.4974C11.381 12.4974 12.5003 11.3781 12.5003 9.9974C12.5003 8.61668 11.381 7.4974 10.0003 7.4974C8.61962 7.4974 7.50034 8.61668 7.50034 9.9974C7.50034 11.3781 8.61962 12.4974 10.0003 12.4974Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetupTracking);
export default __webpack_public_path__ + "static/media/setup-tracking.2db943cda67705fbf8db2674f7370d99.svg";
export { ForwardRef as ReactComponent };